module.exports = __webpack_public_path__ + "static/world-map-c1ef463a0089219ca05763c3d2269e66.gif";